module.exports = __webpack_public_path__ + "static/media/background-backslash.5de7a90c.svg";